
import { Actions, Getters } from '@/store/modules/StoreModule';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from '@vue/runtime-core';
import Datatable from '@/components/kt-datatable/KTDatatable.vue';
import { hideModal } from '@/core/helpers/dom';
import { dateFormat } from '@/utils/helper/format';

const storeTableHeader = [
  {
    name: '#',
    key: 'selectStore',
    sortable: false,
  },
  {
    name: 'Store',
    key: 'storeDetail',
    sortable: false,
  },
  {
    name: 'Owner',
    key: 'owner',
    sortable: false,
  },
  {
    name: 'Current Package',
    key: 'packageName',
    sortable: false,
  },
  {
    name: 'Date Created',
    key: 'createdAt',
    sortable: false,
  },
];

export default {
  components: {
    Datatable,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [] as any[],
    },
  },
  setup(props, { emit }) {
    const tableRef = ref<any>(null);
    const tableData = ref<any[]>([]);
    const store = useStore();
    const modalRef = ref(null);
    const savedSelectedId = ref<any[]>([]);
    const selectedId = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });
    const stores = computed(() => store.getters[Getters.STORES]);

    onMounted(async () => {
      await store.dispatch(`${Actions.REFETCH_STORE}`);

      const tmp = [...stores.value];
      tableData.value = tmp.splice(0, 10);
    });

    watch(
      () => [
        tableRef.value?.pagination.rowsPerPage,
        tableRef.value?.pagination.page,
      ],
      async ([rows, page]) => {
        const tmp = [...stores.value];
        tableData.value = tmp.splice((page - 1) * rows, rows);
      }
    );

    return {
      tableRef,
      tableData,
      isStoreLoading: computed(() => store.getters[Getters.IS_LOADING]),
      totalStore: computed(() => store.getters[Getters.TOTAL]),
      modalRef,
      closeModal() {
        hideModal(modalRef.value);
      },
      storeTableHeader,
      dateFormat,
      savedSelectedId,
      selectedId,
      handleSelected: (e) => {
        e.preventDefault();
        if (e.target.checked) {
          selectedId.value.push(e.srcElement.dataset.id);
        } else {
          const idx = selectedId.value.indexOf(e.srcElement.dataset.id);

          if (idx > -1) {
            selectedId.value.splice(idx, 1);
          }
        }
      },
      saveBeforeChange() {
        savedSelectedId.value = [...selectedId.value];
      },
      loadSavedSelectedId() {
        selectedId.value = [...savedSelectedId.value];
      },
    };
  },
};
